const valueFormatterWithTwoDecimals = new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export const formatValueWithTwoDecimals = (value) =>
    valueFormatterWithTwoDecimals.format(value.replace(',', '.'));
